<template>
  <div class="c-page-container">
    <c-header-component></c-header-component>
    <c-main-component></c-main-component>
  </div>
</template>
<script>
  import header from '@/layout/header';
  import main from '@/layout/main';
  export default {
    components: {
      'c-header-component': header,
      'c-main-component': main,
    },
    data(){
      return {}
    }
  }
</script>
<style lang="scss" scoped>
  @import '~@/assets/style/public.scss';
  $backgroundImage: #0A103D; //颜色/图片
  $containerWidth: 3200px;
  $containerHeight: 1080px;
  .c-page-container {
    position: relative;
    width: $containerWidth;
    height: $containerHeight;
    background: $backgroundImage;
  }
</style>